<template>
  <div class="calendar--month">
    <h4 class="calendar--title">{{ month.title }}</h4>
    <span class="calendar--header" v-for="(dayHeader, index) in dayHeaders" :key="index">{{ dayHeader }}</span>
    <template v-for="week in month.weeks">
      <hotel-calendar-day v-for="day in week" :day="day" :key="day.KEY" @close="$emit('close')" @keydown.native="handleDayKeydown($event, day)"></hotel-calendar-day>
    </template>
  </div>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2024-05-17 (jhoward)
 *			- Refactor calendar month from hotelCalendar.vue to hotelCalendarMonth.vue.
 */

import {defineComponent, PropType} from 'vue'
import HotelCalendarDay, {CalendarDay} from "./hotelCalendarDay.vue";

export interface CalendarMonth {
  weeks: CalendarDay[][],
  title: string,
  year: number;
  month: number;
}

export default defineComponent({
  name: "hotelCalendarMonth",
  emits: {
    close: () => true,
    seek: (direction: number) => true
  },
  components: {HotelCalendarDay},
  props: {
    month: {
      type: Object as PropType<CalendarMonth>,
      required: true
    }
  },
  data() {
    return {
      dayHeaders: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    };
  },
  methods: {
    handleDayKeydown(event: KeyboardEvent, day: CalendarDay) {
      if (event.key === 'Tab') {
        if (!event.shiftKey && this.isLastDayOfMonth(day)) {
          this.$emit('seek', 1);
        } else if (event.shiftKey && this.isFirstDayOfMonth(day)) {
          this.$emit('seek', -1);
        }
      }
    },
    isLastDayOfMonth(day: CalendarDay): boolean {
      return !!day.DATE && window.pepDateFunctions.addDays(day.DATE, 1).getMonth() !== day.DATE.getMonth();
    },
    isFirstDayOfMonth(day: CalendarDay): boolean {
      return !!day.DATE && window.pepDateFunctions.addDays(day.DATE, -1).getMonth() !== day.DATE.getMonth();
    },
  }
})
</script>

<style scoped>
.calendar--month {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-row-gap: 1px;
  grid-column-gap: 0;
  background-color: #E0E0E0;
}

.calendar--month-hide {
  display: none;
}

.ui-mobile .calendar--month {
  grid-row: 1;
}

.calendar--header {
  padding: 0.25em;
  text-align: center;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
  background: #fff;
  align-content: center;
}

.calendar--title {
  font-size: 1.5em;
  grid-column: 1 / -1;
  text-align: center;
  align-content: center;
  background: #fff;
}
</style>